/**
 * @module attribute value reports
 */
import { createReducer } from '@reduxjs/toolkit';
import { reportingActions } from '~/behaviors/actions/reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeAttributeValueResponses = (state, action) => {
  const attributeValueResponses = action?.payload?.entities?.attributeValueResponses || {};

  Object.values(attributeValueResponses).forEach((attributeValueResponse) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[attributeValueResponse.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[attributeValueResponse.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...attributeValueResponse,
    };
  });
};

const attributeValueResponses = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(reportingActions.fetchQuestionAttributeResponses.fulfilled, mergeAttributeValueResponses);
});

export default attributeValueResponses;
